<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAccount" (ngSubmit)="save()" id="accountEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} account</h2>
        <mat-dialog-content *ngIf="Copy">
            <mat-tab-group>
                <mat-tab label="General">
                    <div class="row">
                        <div class="col-12">
                            <app-account-selector *ngIf="!Student" name="Account" [(ngModel)]="Copy.Account" [distanceTo]="Copy.Activation?.Address?.LatLng" [matSuffix]="matSuffix"></app-account-selector>
                            <ng-template #matSuffix>
                                <button (click)="true" *ngIf="!Student" mat-icon-button matTooltip="Search an account" type="button">
                                  <mat-icon>search</mat-icon>
                                </button>
                            </ng-template>
                            <mat-form-field *ngIf="Student">
                              <mat-label>Firstname and Lastname</mat-label>
                                <input matInput [value]="Copy.Account.FirstName + ' ' + Copy.Account.LastName" disabled="true">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" *ngIf="!Student">
                            <app-dropdown-option name="Status" placeholder="Status" model="ActivationAccount" discriminator="Status" [(ngModel)]="Copy.Status"></app-dropdown-option>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-form-field>
                            <mat-label>Spoken</mat-label>
                                <input matInput name="Spoken" type="number" [(ngModel)]="Copy.Spoken">
                                <mat-hint># of Customers you spoke too</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <mat-form-field>
                              <mat-label>Convinced</mat-label>
                                <input matInput name="Convinced" type="number" [(ngModel)]="Copy.Convinced" max="{{Copy.Spoken}}"
                                       errorValidator [validation]="Copy.Convinced > Copy.Spoken">
                                <mat-hint># of Customers you convinced</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <mat-form-field>
                              <mat-label>Reminded</mat-label>
                                <input matInput name="Reminded" type="number" [(ngModel)]="Copy.Reminded" max="{{Copy.Spoken}}"
                                       errorValidator [validation]="Copy.Bought > Copy.Spoken">
                                <mat-hint># of Customers who knew E&C</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <mat-form-field>
                              <mat-label>Bought</mat-label>
                                <input matInput name="Bought" type="number" [(ngModel)]="Copy.Bought" max="{{Copy.Spoken}}"
                                       errorValidator [validation]="Copy.Bought > Copy.Spoken">
                                <mat-hint># of Customers who bought E&C in the past</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field>
                              <mat-label>Vouchers Dog</mat-label>
                                <input matInput name="VoucherDog" type="number" [(ngModel)]="Copy.VoucherDog">
                                <mat-hint># of vouchers given out (Dog)</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field>
                              <mat-label>Vouchers Cat</mat-label>
                                <input matInput name="VoucherCat" type="number" [(ngModel)]="Copy.VoucherCat">
                                <mat-hint># of vouchers given out (Cat)</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                          <mat-form-field>
                            <mat-label>Received Info Mail</mat-label>
                            <input name="ReceivedInfoMail" [ngModel]="Copy.ReceivedInfoMail | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.ReceivedInfoMail = $event"  matInput type="datetime-local">
                          </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Time">
                  <mat-form-field>
                    <mat-label>Left home</mat-label>
                    <input name="LeavedHome" [ngModel]="Copy.LeavedHome | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.LeavedHome = $event"  matInput type="datetime-local">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Arrived on site</mat-label>
                    <input name="Arrived" [ngModel]="Copy.Arrived | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.Arrived = $event"  matInput type="datetime-local">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Left site</mat-label>
                    <input name="Leaved" [ngModel]="Copy.Leaved | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.Leaved = $event"  matInput type="datetime-local">
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Arrived home</mat-label>
                    <input name="ArrivedHome" [ngModel]="Copy.ArrivedHome | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.ArrivedHome = $event"  matInput type="datetime-local">
                  </mat-form-field>
                    <mat-form-field>
                      <mat-label>Break</mat-label>
                        <input matInput type="time" name="Break" required
                               [ngModel]="secondsToTime()"
                               (ngModelChange)="Copy.Break = timeToSeconds($event);">
                        <mat-icon matIconSuffix>access_time</mat-icon>
                    </mat-form-field>
                </mat-tab>
                <mat-tab label="Distance and expenses">
                    <div *ngIf="Copy.Expenses" class="row">
                        <div class="col-12">
                            <span class="warn">Make sure you upload pictures of the expenses. We cannot pay the expenses without pictures of the tickets or invoices!</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Traveled distance</mat-label>
                                <input name="TraveledDistance" type="number" matInput [(ngModel)]="Copy.TraveledDistance">
                                <span matSuffix>km</span>
                                <mat-hint>Total traveled distance</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Expenses</mat-label>
                                <input name="Expenses" type="number" matInput [(ngModel)]="Copy.Expenses">
                                <mat-hint>Total expenses</mat-hint>
                                <span matSuffix>EUR</span>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Feedback">
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Feedback for yourself</mat-label>
                                <textarea matInput name="FeedbackYourself" [(ngModel)]="Copy.FeedbackYourself" placeholder="Feedback for yourself"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Feedback about the customers</mat-label>
                                <textarea matInput name="FeedbackCustomers" [(ngModel)]="Copy.FeedbackCustomers"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Feedback from the store about you</mat-label>
                                <textarea matInput name="FeedbackStore" [(ngModel)]="Copy.FeedbackStore"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Score you give yourself (1-4)</mat-label>
                                <input matInput type="number" max="4" min="1" step="1" name="ScoreYourself" [ngModel]="Copy.ScoreYourself"
                                       (ngModelChange)="Copy.ScoreYourself = $event === null ? null : ($event <= 1 ? 1 : ($event >= 4 ? 4 : ($event === 0 ? 1 : null)))">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>

        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
